import { render, staticRenderFns } from "./GlobalUserPopover.vue?vue&type=template&id=03fa9272&scoped=true"
import script from "./GlobalUserPopover.vue?vue&type=script&lang=js"
export * from "./GlobalUserPopover.vue?vue&type=script&lang=js"
import style0 from "./GlobalUserPopover.vue?vue&type=style&index=0&id=03fa9272&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fa9272",
  null
  
)

export default component.exports